<script setup lang="ts">
import "vue-sonner/style.css";

import { Toaster } from "vue-sonner";

import { useTheme } from "@/shared/composables/useTheme";

defineOptions({ name: "Sonner" });

const { resolvedTheme } = useTheme();
</script>

<template>
  <Toaster
    class="toaster group"
    :theme="resolvedTheme"
    position="top-right"
    rich-colors
    :toast-options="{
      style: {
        background: 'var(--popover)',
        color: 'var(--popover-foreground)',
        border: '1px solid var(--border)',
      },
    }"
  />
</template>
